import React from 'react';
import { Reveal } from './Reveal';
const problems = ['Vous arrivez en séance sans plan réel et structuré.', 'Vous passez des heures à chercher des supports avant chaque intervention.', 'Vous avez des centaines de fiches sauvegardées mais ne savez pas comment les articuler.', 'Les niveaux de vos patients varient énormément et vous ne savez pas comment adapter.', 'Vous ne savez pas comment structurer un suivi complet du bilan initial aux objectifs finaux.', 'Les séances semblent toujours improvisées et désorganisées.'];
export function Problems() {
  return <section className="w-full bg-ink-soft px-4 py-20" data-id="element-186">
      <div className="mx-auto max-w-3xl" data-id="element-187">
        <Reveal data-id="element-188">
          <h2 className="text-center font-display text-3xl uppercase leading-tight text-white sm:text-4xl" data-id="element-189">
            Si vous êtes professionnel en cabinet, vous vivez probablement l'un
            de ces problèmes :
          </h2>
        </Reveal>

        <ul className="mt-10 space-y-4" data-id="element-190">
          {problems.map((p, i) => <Reveal key={p} delay={i * 0.05} data-id="element-191">
              <li className="flex items-start gap-3 rounded-xl border border-ink-border bg-ink-card p-4 text-white/80" data-id="element-192">
                <span className="mt-0.5 text-lg" data-id="element-193">❌</span>
                <span className="text-sm leading-relaxed sm:text-base" data-id="element-194">
                  {p}
                </span>
              </li>
            </Reveal>)}
        </ul>

        <Reveal delay={0.1} data-id="element-195">
          <p className="mt-10 text-center font-display text-2xl uppercase leading-tight text-gold sm:text-3xl" data-id="element-196">
            Combien de séances de plus voulez-vous continuer à improviser ?
          </p>
        </Reveal>
      </div>
    </section>;
}